module.exports = __webpack_public_path__ + "img/5.92e3baaf.jpg";